import { useState } from 'react';
import { Grid2 as Grid, Container } from '@mui/material';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import MainFooter from '../../components/layout/MainFooter';
import StepsSignUp from '../../components/auth/StepsSignUp';
import FormSignUpStep2 from '../../components/auth/FormSignUpStep2';
import FormSignUpStep3 from '../../components/auth/FormSignUpStep3';
import { addUser } from '../../actions/users';
import { setAlert } from '../../actions/alert';

import { connect } from 'react-redux';

const SignUpSteps = ({
  addUser, setAlert
}) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [pasos, setPasos] = useState(1);
  const [data, setData] = useState({
    to: '',
    infoUser: '',
    emailTel: "celular"
  });

  if (state == undefined) {
    return <Navigate exact to="/signup" />
  }

  return (
    <Container component="main" maxWidth="lg">
      <Grid className="container-steps" container spacing={{ lg: 3 }}>
        <StepsSignUp
          pasos={pasos}
        />
        {
          pasos === 1 ? (
            <FormSignUpStep2
              navigate={navigate}
              setPasos={setPasos}
              setData={setData}
              data={data}
              state={state}
            />
          ) : (
            <FormSignUpStep3
              navigate={navigate}
              data={data}
              addUser={addUser}
              setAlert={setAlert}
            />
          )
        }
      </Grid>
      <MainFooter />
    </Container>
  );
}

SignUpSteps.propTypes = {
  setAlert: PropTypes.func.isRequired,
  addUser: PropTypes.func.isRequired
}

export default connect(null, {
  setAlert,
  addUser
})(SignUpSteps);